import countryLangStore from "@zustand/countryLang";
import axiosInstance from "./config";
import { handleValueCondition } from "@utils/manageValue";

interface IApi {
  urlPath: string;
  body?: any;
  headers?: any;
  auth?: boolean;
}
interface IAuthToken {
  Authorization: string;
}

interface IDefaultReturnData extends IApi {
  method: "PUT" | "PATCH";
}

const config = ({ urlPath, headers, auth = false }: IApi) => {
  const url = `${process.env.REACT_APP_API_DOMAIN}${urlPath}`;
  const country = countryLangStore?.getState()?.country?.id;
  const country_id = country ? { country_id: country } : { country_id: "1" };
  const defaultLang = {
    "language-key":
      countryLangStore.getState().lang ??
      `${process.env.REACT_APP_COUNTRY_LANG}`,
  };
  const corporation =
    countryLangStore.getState().user?.corporation_code ?? "bkp";
  const corporation_code = {
    corporation_code: `["${corporation}"]`,
  };

  let authToken: IAuthToken = {
    Authorization: "",
  };
  if (
    localStorage.getItem("qovis-oversea") &&
    JSON.parse(localStorage.getItem("qovis-oversea") ?? "").state.user &&
    auth
  ) {
    const bearer_token =
      JSON.parse(localStorage.getItem("qovis-oversea") ?? "").state.user
        ?.access_token ?? "";
    if (!bearer_token) {
      window.location.reload();
    }
    const headersBearer = `Bearer ${bearer_token}`;
    authToken = {
      Authorization: headersBearer,
    };
  }

  const configHeaders = {
    ...country_id,
    ...defaultLang,
    ...authToken,
    ...corporation_code,
  };

  const headerConfig = handleValueCondition(headers, headers, configHeaders);

  return { url, configHeaders: headerConfig };
};

export const Get = async ({ urlPath, headers, auth }: IApi) => {
  const { url, configHeaders } = config({ urlPath, headers, auth });
  return axiosInstance({
    method: "GET",
    url,
    headers: {
      ...configHeaders,
    },
  })
    .then((res) => {
      return {
        status: true,
        message: res.data,
      };
    })
    .catch((err) => {
      return {
        status: false,
        message: err,
      };
    });
};

export const Post = async ({ urlPath, headers, auth, body }: IApi) => {
  const { url, configHeaders } = config({ urlPath, headers, auth });
  return axiosInstance({
    method: "POST",
    headers: {
      ...configHeaders,
    },
    url,
    data: body,
  })
    .then((res) => {
      return {
        status: true,
        message: res.data,
      };
    })
    .catch((err) => {
      return {
        status: false,
        message: err?.response?.data?.error?.message ?? "",
      };
    });
};

export const Patch = async ({ urlPath, headers, auth, body }: IApi) => {
  return defaultReturnData({
    urlPath,
    headers,
    auth,
    body,
    method: "PATCH",
  });
};

export const Put = async ({ urlPath, headers, auth, body }: IApi) => {
  return defaultReturnData({
    urlPath,
    headers,
    auth,
    body,
    method: "PUT",
  });
};

export const Delete = async (url: string, body?: any, headers?: any) => {
  return axiosInstance({
    method: "DELETE",
    headers,
    url,
    data: body,
  })
    .then((res) => {
      return {
        status: true,
        message: res,
      };
    })
    .catch((err) => {
      return {
        status: false,
        message: err,
      };
    });
};

export const PostDefault = async (url: string, body?: any, headers?: any) => {
  return axiosInstance({
    method: "POST",
    headers,
    url,
    data: body,
  })
    .then((res) => {
      return {
        status: true,
        message: res,
      };
    })
    .catch((err) => {
      return {
        status: false,
        message: err?.response?.data,
      };
    });
};

const defaultReturnData = ({
  urlPath,
  headers,
  auth,
  body,
  method,
}: IDefaultReturnData) => {
  const { url, configHeaders } = config({ urlPath, headers, auth });
  return axiosInstance({
    method: method,
    headers: {
      ...configHeaders,
    },
    url,
    data: body,
  })
    .then((res) => {
      return {
        status: true,
        message: res,
      };
    })
    .catch((err) => {
      return {
        status: false,
        message: err,
      };
    });
};
